import { css } from '@emotion/core';
import styled from '@emotion/styled';
import { BaseIcon } from './index.elements';

export const Icon = styled(BaseIcon)(css`
  width: 16px;
  height: 17px;
`);
